module.exports = __webpack_public_path__ + "static/media/036.7013920b.jpg";